<template>
  <div style="display:flex; width: 100%;">
    <div class="credit-field" style="flex: 120px">
      <div class="label">クレジットカード番号</div>
      <template class="field">
        <div class="card-number-container">
          <div id="card-number"></div>
          <transition name="fade">
            <img v-if="getCardSrc" :src="getCardSrc" />
          </transition>
        </div>

        <span class="warning" v-if="cardNumberError">
          {{
          cardNumberError
          }}
        </span>
      </template>
    </div>

    <div class="credit-field" style="flex: 1">
      <div class="label">有効期限</div>
      <template class="field">
        <div id="card-expiry"></div>
        <span class="warning" v-if="cardExpiryError">
          {{
          cardExpiryError
          }}
        </span>
      </template>
    </div>

    <div class="credit-field" style="flex: 70px">
      <div class="label">名義人</div>
      <template class="field">
        <div class="card-name-container">
          <div id="card-name"></div>
          <input
            type="text"
            placeholder="HATSUON TARO"
            class="StripeElement"
            style="height: 16.797px"
            v-model="cardName"
            :class="[
                  { complete: nameValid },
                  { error: !nameValid && cardName.length > 0 }
                ]"
          />
        </div>

        <span class="warning" v-if="nameValidationMessage">
          {{
          nameValidationMessage
          }}
        </span>
      </template>
    </div>
    <div class="credit-field" style="flex: 50px">
      <div class="label">セキュリティコード</div>
      <template class="field">
        <div id="card-cvc"></div>
        <span class="warning" v-if="cardCvcError">{{ cardCvcError }}</span>
      </template>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import firebase from "firebase/app";
import "firebase/functions";

export default {
  watch: {
    cardName() {
      if (!this.cardName) {
        this.nameValid = false;
      }
      if (!/[a-zA-Z]{2}/.test(this.cardName) || /\d+/.test(this.cardName)) {
        this.nameValidationMessage = "2文字以上の半角英字で入力してください";
        this.nameValid = false;
      } else {
        this.nameValidationMessage = "";
        this.nameValid = true;
      }
    }
  },
  data() {
    return {
      stripe: new Stripe("pk_live_Ua29BMKQgKZf1HtC7EnLuocg00jmKCDQTU"),
      cardNumber: null,
      cardName: "",
      nameValid: false,
      nameValidationMessage: "",
      cardExpiry: null,
      cardCvc: null,
      cardNumberError: null,
      cardExpiryError: null,
      cardCvcError: null,
      cardType: null
    };
  },
  methods: {
    saveToken(e) {
      return new Promise(resolve => {
        let self = this;
        const cardLoading = Loading.service({
          lock: true,
          text:
            "現在クレジットカード情報の変更しています、ウィンドウを閉じないようにお願い致します",
          background: "rgba(255, 255, 255, 0.9)",
          customClass: "loading"
        });
        this.stripe
          .createToken(this.cardNumber)
          .then(response => {
            if (response.error) {
              cardLoading.close();
              return;
            }
            const functions = firebase.functions();
            const changePaymentSource = firebase
              .functions()
              .httpsCallable("changePaymentSource");
            changePaymentSource({
              source: response,
              name: self.cardName
            }).then(result => {
              cardLoading.close();
              resolve();
            });
          })
          .catch(err => {
            console.log(err);
            cardLoading.close();
          });
      });
    }
  },
  computed: {
    getCardSrc() {
      if (this.cardType === "unknown") {
        return null;
      } else if (this.cardType) {
        return require("@/assets/cards/" + this.cardType + ".svg");
      }
    }
  },
  beforeMount() {
    let self = this;
    const elements = this.stripe.elements();

    const status = this.$store.state.userData.subscription.status;

    const elementStyles = {
      border: "1px"
    };
    const elementClasses = {};

    // カード番号
    this.cardNumber = elements.create("cardNumber");
    this.cardNumber.addEventListener("change", e => {
      self.cardType = e.brand;
      if (e.error) {
        this.cardNumberError = e.error.message;
      } else {
        this.cardNumberError = "";
      }
    });

    // カードの有効期限
    this.cardExpiry = elements.create("cardExpiry");

    this.cardExpiry.addEventListener("change", e => {
      if (e.error) {
        this.cardExpiryError = e.error.message;
      } else {
        this.cardExpiryError = "";
      }
    });
    // カードのCVC入力
    this.cardCvc = elements.create("cardCvc");

    this.cardCvc.addEventListener("change", e => {
      if (e.error) {
        this.cardCvcError = e.error.message;
      } else {
        this.cardCvcError = "";
      }
    });
  },
  mounted() {
    this.cardNumber.mount("#card-number");
    this.cardExpiry.mount("#card-expiry");
    this.cardCvc.mount("#card-cvc");
  },
  beforeDestroy() {
    this.cardNumber.unmount("#card-number");
    this.cardExpiry.unmount("#card-expiry");
    this.cardCvc.unmount("#card-cvc");
  }
};
</script>

<style lang="scss" scoped>
.cc-form {
  margin: 0 auto;
  max-width: 700px;
}
.StripeElement {
  outline: none;
  border: 1px solid #dcdfe6;
  background-color: #fff;
  font-size: 0.8rem;
  padding: 10px 15px;
  border-radius: 5px;
  color: #606266;
  user-select: none;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  &--invalid {
    border: 1px solid #f56c6c;
  }
  &--complete {
    border: 1px solid #67c23a;
  }
  &--focus {
    border: 1px solid #b1b4bb;
  }
}
.warning {
  color: #f56c6c;
  font-size: 13px;
  margin-left: 2px;
}

.secure {
  text-align: center !important;
  padding: 10px 0 42px 0;
  font-size: 0.9rem;
  background: #efefef;
  border-radius: 5px;
  margin: 25px 0;
  position: relative;
  p {
    margin: 0;
  }
  img {
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: 0 auto;
    user-select: none;
    &:hover {
      opacity: 0.7;
    }
  }
}

.credit-field {
  margin: 10px;
  .label {
    margin-bottom: 5px;
  }
}

.card-number-container {
  position: relative;
  img {
    position: absolute;
    width: 37px;
    top: 8px;
    right: 7px;
    user-select: none;
  }
}
.complete {
  border: 1px solid #67c23a;
}

.error {
  border: 1px solid #f56c6c;
}
</style>
